/**
 * Centralized react-query keys.
 *
 * Keeping every key in one place avoids typos, keeps cache identity consistent
 * across hooks, and makes targeted invalidation from mutations easy
 * (e.g. `queryClient.invalidateQueries(QUERY_KEYS.favoritePlans.all)`).
 */
export const QUERY_KEYS = {
    favoritePlans: {
        all: ['favorite-plans'],
        list: (filters = {}) => ['favorite-plans', filters],
        detail: (id) => ['favorite-plans', 'detail', id],
        nameExists: (planName) => ['favorite-plans', 'name-exists', planName],
    },
    favoritePlanMetrics: {
        all: ['favorite-plan-metric'],
        detail: (metric, period) => ['favorite-plan-metric', metric, period],
    },
};

export default QUERY_KEYS;
